/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {EUserStatus} from "../../../containers/pages/admin/AddUser/ConfigureUser/constants";

export type TPermissions = { [key: string]: EUserPermissionAccess }

export interface IUser {
  id: string
  permissions: any
  firstName: string
  lastName: string
  email: string
  userStatus: EUserStatus
  loginCount: number
}

/**
 * WARNING: THIS DEFINES THE ORDER OF THE 'EDIT/ADD USER' TABLE COLUMNS, SO MAKE SURE YOU KEEP THE ORDER WE WANT.
 */
export enum EUserPermissionAccess {
  NO_ACCESS = 'No Access',
  READ_ONLY = 'Read Only',
  READ_WRITE = 'Read/Write',
}